import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, Checkbox, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, CircularProgress, Container, FormControlLabel, Grid, TextField,} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {CommodityTypeService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import {NotificationContext} from "../../../components/NotificationContext";
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';

const CommodityTypeForm = () => {
    const methods = useForm();
    const {handleSubmit, control, setValue, errors} = methods;

    const [data, setData] = useState({});
    const [isReady, setIsReady] = useState(false);
    const {showMessage, showError} = useContext(NotificationContext);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const {rights} = useContext(CurrentUserContext);

    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );

      const handleClose = () => {
        setOpen(false);
        setOpenConfirmation(false);
        setOpenInfo(false);
    }

    const removeCommodityType = () => {
        setShowProgress(true);
        CommodityTypeService.delete(data.id).then((response) => {                
                showMessage('Successfully Deleted');
                history.push("/references/commodity-types");   
                setShowProgress(false);                                
            }).catch((response) => {
            handleClose();
            setOpenInfo(true);
            setShowProgress(false);                                

        });
    }
      
      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    useEffect(() => {
        if (id !== "new") {
            CommodityTypeService.getById(id).then((response) => {
                setData(response.data);
                setIsReady(true);
            });
        } else {
            setData({});
            setIsReady(true);
        }
    }, [id, setValue]);


    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            CommodityTypeService
                .update({...data, ...d})
                .then((response) => {
                    showMessage('Commodity Type updated.')
                }).catch((response)=>{
                    showError(response.message);
                });
        } else {
            CommodityTypeService.create({...data, ...d}).then((response) => {
                setData(response.data);
                showMessage('Commodity Type Created.');
            });
        }
        setTimeout(() => {
            setIsReady(true);
            history.push('/references/commodity-types')
        }, 100) 
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
    return (
        <Container>
            <header>
                <h1>Commodity Type</h1>
            </header>
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)}  onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container>
                    <Grid item xs={12}>
                        <p>
                            Commodity types are types influencing what document is sent with shipment.
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="typeCode"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Code"
                            color="primary"
                            defaultValue={data.typeCode}
                            rules={{required: 'Type code is required.'}}
                            variant="outlined"
                        />
                        <ValidationError error={errors.typeCode}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <Controller
                            name="name"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Name"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Name is required.'}}
                            defaultValue={data.name}
                        />
                        <ValidationError error={errors.name}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <FormControlLabel label="Registration Required By Default" variant="outlined" control={
                            <Controller
                                name="registrationRequiredByDefault"
                                control={control}
                                color="primary"
                                variant="outlined"
                                defaultValue={data.registrationRequiredByDefault}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>

                    </Grid>
                    <Grid item xs={9}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                    </Grid>
                    {(rights.includes("ROLE_SI_ADMIN") && id !== 'new') &&    
                        <Grid item xs={3}>
                            <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove Commodity type</Button>
                        </Grid>
                     } 
                </Grid>
                             
             <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
            <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this commodity type?                                           
                    </DialogContent>
                    <DialogActions>
                        {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>}                       
                    <Button onClick={removeCommodityType} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openInfo} onClose={handleClose} aria-labelledby="form-dialog-title">                   
                    <DialogContent>                       
                          This commodity type can not be deleted because it is already in use.                                             
                    </DialogContent>
                    <DialogActions>                    
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
        </Container>
    );
};

export default CommodityTypeForm;
